export type BillPdf = {
	data: string;
	type: 'PDF' | 'URL';
};

const model: types.models.InputModel = {
	type: 'response.getCustomerBillsResponse.customerBill.attachment.type',
	data: 'response.getCustomerBillsResponse.customerBill.attachment.data',
};

export default model;
